export enum PaymentProcessor {
    PAYPAL,
    VANTIV_HOSTED,
    HEARTLAND,
    E_XACT,
    VANTIV
}

export enum PaymentMethod {
    Cash = 'CSH',
    Check = 'CHK',
    Card = 'HST',
    MoneyOrder = 'MON',
    Other = 'OTH'
}

export enum PaymentSource {
    Online = 'ONL',
    WalkIn = 'WLK',
    CallIn = 'CAL',
    MailIn = 'MAI',
}

export enum HostedPaymentType {
    Form,
    IFrame,
    UserEntry
}

export enum IFrameType {
    Vantiv
}

export enum E_XactPaymentType {
    Citation = 1,
    Other = 3
}
